<template>
    <div>
        <el-dialog title="批量添加题目" width="700px" class="icon-dialog" :visible.sync="show" @open="open"
            :before-close="closeForm" append-to-body>
            <el-form :size="size" :rules="rules" :model="form" ref="form" :label-width="$store.getters.device !== 'mobile'?'16%':'90px'">
                <el-form-item label="当前分类：">
                    <div>{{ form.classify }}</div>
                </el-form-item>
                <div style="margin-top: 10px;">
                    <el-form-item label="json：">
                        <el-input type="textarea" v-model="form.json"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" :loading="loading" type="primary" @click="submit">
                    <span v-if="!loading">确 定</span>
                    <span v-else>提 交 中...</span>
                </el-button>
                <el-button :size="size" @click="closeForm">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getclassifyallEdit } from '../../api/userMG';

export default {
    name: 'bannerupdate',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'small'
        },
        info: {
            type: Object,
        },
    },
    data() {
        return {
            form: {
                pcid: '',
                classify: '',
                json: ''
            },
            rules: {
			},
            loading: false,
        }
    },
    methods: {
        open() {
            console.log(this.info, '+++++++++++++++++++++++++++');
            this.form.classify = this.info.classify
            this.form.pcid = this.info.pcid

        },
        submit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.loading = true
                    getclassifyallEdit(this.form).then(res => {
                        if (res.code == 200) {
                            this.$message({ message: '操作成功', type: 'success' })
                            this.$emit('refesh_list')
                            this.closeForm()

                        } else {
                            this.$message({ message: res.msg, type: 'error' })
                            this.loading = false
                        }
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        closeForm() {
            this.$emit('update:show', false)
            this.loading = false
            this.form.pcid = '' 
            this.form.classify = '' 
            this.form.json = '' 
            if (this.$refs['form'] !== undefined) {
                this.$refs['form'].resetFields()
            }
        },
    }
}
</script>
<style scoped >
.flexs {
    display: flex;
    width: 500px;
    justify-content: space-between;
    margin-top: 20px;
}

.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed red;

}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 90px;
    height: 90px;
    line-height: 90px;
    text-align: center;
}

.avatar {
    width: 90px;
    height: 90px;
    display: block;
    border: 1px solid #E1E1E1;
}
</style>



// WEBPACK FOOTER //
// src/views/group/adds.vue